module.exports = __webpack_public_path__ + "static/media/geolocation.de0e9d65.png";